module["exports"] = [
  "#{street_name}, #{building_number}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/street_address.js
// module id = 1655
// module chunks = 1